import { WORLD_FILE, WORLD_SLUG } from './format.js';
import { isRecord } from './util.js';
/** Served old names, keeping only names that map to names (`{features, states}`); undefined else. */
export function servedAliasesOf(raw) {
    if (!isRecord(raw))
        return undefined;
    const names = (value) => {
        const out = {};
        if (!isRecord(value))
            return out;
        for (const [old, now] of Object.entries(value))
            if (typeof now === 'string')
                Object.defineProperty(out, old, {
                    value: now,
                    enumerable: true,
                    writable: true,
                    configurable: true,
                });
        return out;
    };
    const states = {};
    if (isRecord(raw['states']))
        for (const [feature, value] of Object.entries(raw['states']))
            Object.defineProperty(states, feature, {
                value: names(value),
                enumerable: true,
                writable: true,
                configurable: true,
            });
    return { features: names(raw['features']), states };
}
/** A served answer's `worlds`, keeping only entries of the right shape (the format is checked by the reader). */
export function servedWorldsOf(raw) {
    if (!isRecord(raw))
        return {};
    const out = {};
    for (const [slug, entry] of Object.entries(raw)) {
        if (!WORLD_SLUG.test(slug))
            continue;
        if (!isRecord(entry) || entry['slug'] !== slug || typeof entry['itemId'] !== 'string')
            continue;
        if (!isRecord(entry['package']) || !isRecord(entry['files']))
            continue;
        const files = Object.entries(entry['files']);
        if (!files.every(([name, f]) => WORLD_FILE.test(name) &&
            isRecord(f) &&
            typeof f['mediaId'] === 'string' &&
            typeof f['bytes'] === 'number'))
            continue;
        if (entry['sky'] !== null && !isRecord(entry['sky']))
            continue;
        Object.defineProperty(out, slug, {
            value: entry,
            enumerable: true,
            writable: true,
            configurable: true,
        });
    }
    return out;
}
//# sourceMappingURL=served.js.map